/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CoinMarketData } from '../models/coin-market-data';

@Injectable({
  providedIn: 'root',
})
export class MarketDataControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getMarketDataUsingGet
   */
  static readonly GetMarketDataUsingGetPath = '/frontend/market-data/{currencyName}';

  /**
   * Return coin market data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMarketDataUsingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketDataUsingGet$Response(params: {

    /**
     * CoinGecko coin  ID
     */
    currencyName: 'PLN' | 'GBP' | 'HUF' | 'USD' | 'BCH' | 'LUNA' | 'DAI' | 'DASH' | 'CZK' | 'EUR' | 'ADA' | 'BTC' | 'ETH' | 'LTC' | 'SOL' | 'TRX' | 'USDT' | 'XRP' | 'DOGE' | 'BNB' | 'AVAX' | 'LINK' | 'DOT' | 'STX' | 'NEAR' | 'FIL' | 'WIF' | 'ETC' | 'FET' | 'ARB' | 'TAO' | 'AR' | 'S' | 'INJ' | 'ATOM' | 'UNI' | 'ICP' | 'SUI' | 'HBAR' | 'APT' | 'MKR' | 'RUNE' | 'AGIX' | 'AAVE' | 'OP' | 'IO' | 'JTO' | 'PEPE' | 'SHIB' | 'POL' | 'WLD' | 'USDC';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CoinMarketData>> {

    const rb = new RequestBuilder(this.rootUrl, MarketDataControllerService.GetMarketDataUsingGetPath, 'get');
    if (params) {
      rb.path('currencyName', params.currencyName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CoinMarketData>;
      })
    );
  }

  /**
   * Return coin market data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMarketDataUsingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMarketDataUsingGet(params: {

    /**
     * CoinGecko coin  ID
     */
    currencyName: 'PLN' | 'GBP' | 'HUF' | 'USD' | 'BCH' | 'LUNA' | 'DAI' | 'DASH' | 'CZK' | 'EUR' | 'ADA' | 'BTC' | 'ETH' | 'LTC' | 'SOL' | 'TRX' | 'USDT' | 'XRP' | 'DOGE' | 'BNB' | 'AVAX' | 'LINK' | 'DOT' | 'STX' | 'NEAR' | 'FIL' | 'WIF' | 'ETC' | 'FET' | 'ARB' | 'TAO' | 'AR' | 'S' | 'INJ' | 'ATOM' | 'UNI' | 'ICP' | 'SUI' | 'HBAR' | 'APT' | 'MKR' | 'RUNE' | 'AGIX' | 'AAVE' | 'OP' | 'IO' | 'JTO' | 'PEPE' | 'SHIB' | 'POL' | 'WLD' | 'USDC';
  },
  context?: HttpContext

): Observable<CoinMarketData> {

    return this.getMarketDataUsingGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<CoinMarketData>) => r.body as CoinMarketData)
    );
  }

}
